import { DashboardWidget } from './dashboard-widgets.model';

export function transformDashboardWidgets(
  dashboardWidget: DashboardWidget,
): DashboardWidget {
  return dashboardWidget;
}
